<template>
  <a-layout id="components-layout-demo-custom-trigger" :style="{height:inner.height+'px'}" ref="layoutFull">
    <a-layout>
      <IHeader />
      <a-layout>
        <a-layout-sider v-show="showMenu" :trigger="null" collapsible v-model="collapsed" theme='light' style="overflow-y:scroll;overflow-x:hidden;">
          <div class="menu-title" :style="menuTitle">
            <span :style="{width:collapsed?'0px':'100px','overflow':'hidden','white-space':'nowrap'}">{{PROJECT_NAME}}</span>
            <a-icon class="trigger" size='large' :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="()=> collapsed = !collapsed" />
          </div>
          <IMenu :collapsed='collapsed' :trigger="null" theme='light' />
        </a-layout-sider>
        <a-layout-content :style="layoutContent">
          <Breadcrumb />
          <vue-page-transition name="fade-in-down" :style="vuePageTransition">
            <router-view :key="routerViewKey" />
          </vue-page-transition>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </a-layout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import debounce from 'lodash.debounce'
  import IMenu from '@/components/Menu'
  import Breadcrumb from '@/components/Breadcrumb'
  import IHeader from '@/components/Header'
  import { PROJECT_NAME } from '@/config/application'
  export default {
    name: 'BasicLayout',
    data() {
      return {
        collapsed: false,
        routerViewKey: 1
      }
    },
    created() {
      this.initStaticState()
      this.updateLayout()
    },
    mounted() {
      window.onresize = debounce(this.updateLayout, 300)
    },
    computed: {
      ...mapGetters(['inner', 'showMenu'])
    },
    methods: {
      ...mapActions(['setInner']),
      initStaticState() {
        this.PROJECT_NAME = PROJECT_NAME
        this.layoutContent = {
          margin: '0px 0px',
          padding: '12px',
          minHeight: '280px'
        }
        this.vuePageTransition = {
          height: 'calc(100% - 40px)'
        }
        this.menuTitle = {
          'justify-content': 'center'
        }
      },
      async updateLayout() {
        await this.setInner({
          width: window.innerWidth,
          height: window.window.innerHeight
        })
      }
    },
    watch: {
      $route() {
        this.routerViewKey++
      }
    },
    components: {
      IMenu,
      Breadcrumb,
      IHeader
    }
  }
</script>

<style lang="less">
  #components-layout-demo-custom-trigger .trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color 0.3s;
  }

  #components-layout-demo-custom-trigger .trigger:hover {
    color: #1890ff;
  }

  #components-layout-demo-custom-trigger .logo {
    height: 32px;
    background: rgba(255, 255, 255, 0.2);
    margin: 16px;
  }
  .content-full {
    height: 100%;
    display: flex;
    justify-content: space-between;
  }

  .menu-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 24px;
    font-weight: 600;
    span {
      transition: all 0.5s;
    }
  }
  .menu-full {
    overflow-y: scroll;
  }
  .header {
    background: #001529;
    padding-left: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .header-logo {
      height: 100%;
    }
  }
</style>
